import { Navigate, Outlet } from "react-router-dom";
import { useUserRoles } from "../hooks/useUserRoles";

type Props = {
  roles: string[];
};

export const RoleGuard: React.FC<Props> = ({ roles: allowedRoles }) => {
  const roles = useUserRoles();
  const lowerRoles = roles.map((r) => r.toLowerCase());
  const hasRole = allowedRoles.some((r) => lowerRoles.includes(r.toLowerCase()));
  if (!hasRole) {
    return <Navigate to="/not-found" replace />;
  }
  return <Outlet />;
};
